import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import Loading from 'apa/components/Loading';
import {Button, Input, InputGroup, InputGroupAddon, Label} from 'reactstrap';
import autobind from 'autobind-decorator';
import Dialog from 'apa/containers/Dialog';
import Select from 'react-select';
import {deleteManual, saveManual, selectManual, updateManual, uploadManualFile} from 'manuals/actions/manual';

@connect(
    state => ({
        categoryList: state.manuals.categoryList,
        selectedManual: state.manuals.selectedManual
    }),
    dispatch => {
        return {
            updateManual: (manual) => dispatch(updateManual(manual)),
            saveManual: (manual) => dispatch(saveManual(manual)),
            deleteManual: (manual) => dispatch(deleteManual(manual)),
            selectManual: (manual) => dispatch(selectManual(manual)),
            uploadManualFile: (manualId, data, success) => dispatch(uploadManualFile(manualId, data, success)),
        }
    }
)
export default class ManualPreview extends Component {

    state = {
        template_file: '',
        isDeleteOpen: false,
        uploading: false,
        template: '',
        preview: false,
        uploadError: false,
    }

    constructor(props) {
        super(props);
        this.state = {
            template_file: props.selectedManual.template_file,
        }
        this.categoryList = this.props.categoryList.map(
            category => ({value: category.id, label: category.name})
        )
    }

    @autobind
    confirmDelete() {
        this.props.deleteManual(this.props.selectedManual);
        this.toggleDelete()
    }

    @autobind
    toggleDelete() {
        this.setState({isDeleteOpen: !this.state.isDeleteOpen})
    }

    @autobind
    uploadManualFile(e) {
        this.setState({
            uploading: true
        })
        const data = new FormData()
        const f = e.target.files[0]
        data.append('filename', f, f.name)
        this.props.uploadManualFile(
            this.props.selectedManual.id,
            data,
            () => this.setState({
                uploading: false
            }),
            () => this.setState({
                uploading: false,
                uploadError: true
            })
        )
    }

    @autobind
    changeCategory(categoryList) {
        if(categoryList.length === 0)
            return;
        const category = categoryList.map(category => category.value)
        const manual = {...this.props.selectedManual, category: category}
        this.props.updateManual(manual)
        this.props.saveManual(manual)
    }

    render() {
        const {
            selectedManual,
        } = this.props;
        const defaultCategoryList = this.categoryList.filter(
            category => selectedManual.category.includes(category.value)
        )
        console.log(defaultCategoryList)
        const manual = selectedManual;
        return (
            <Fragment>
                <Label>
                    Name
                </Label>
                <InputGroup>
                    <Input
                        type='text'
                        value={selectedManual.name}
                        onChange={e => this.props.updateManual({...manual, name: e.target.value})}
                        onBlur={() => this.props.saveManual(manual)}
                    />
                    <InputGroupAddon addonType='append'>
                        <Button color='danger' onClick={this.toggleDelete}>
                            <i className='fa fa-trash'> </i>
                        </Button>
                        <Dialog
                            toggle={this.toggleDelete}
                            confirm={this.confirmDelete}
                            isOpen={this.state.isDeleteOpen}
                        >
                            Sind Sie sicher?
                        </Dialog>
                    </InputGroupAddon>
                </InputGroup>
                <Label>
                    Kategorie
                </Label>
                <Select
                    isMulti={true}
                    options={this.categoryList}
                    onChange={this.changeCategory}
                    defaultValue={defaultCategoryList}
                />
                <Label>
                    Neue Vorlage hochladen
                </Label>
                <Input
                    type='file'
                    value={this.state.template}
                    onChange={this.uploadManualFile}
                />
                {this.state.uploading && <Loading/>}
                {this.state.uploadError && <p className='text-danger'>Fehler beim Upload.</p>}
                <br/>
                <a href={manual.filename} target="_blank" rel="noopener noreferrer"
                   className='btn btn-primary'>Download</a>
                <Button color={'primary'} onClick={() => this.setState({preview: !this.state.preview})}>Vorschau
                    öffnen</Button>
                {this.state.preview &&
                <Fragment>
                    <br/>
                    <iframe
                        src={'https://view.officeapps.live.com/op/embed.aspx?src=https://apa.menshikov.de' + manual.filename + '?' + Date.now()}
                        frameBorder="0"
                        width="100%"
                        height="900"
                    >
                        Office365 Vorschau
                    </iframe>
                </Fragment>
                }
            </Fragment>
        )
    }

}
